import { z } from 'zod';

import { defineInvisible } from '@apps/web/features/phoebe_chat_v3/registry/types';

const outreachMonitorWakeUpPayloadSchema = z
    .object({
        type: z.literal('outreach_monitor_wake_up').optional(),
        outreach_id: z.uuid(),
        reason: z.string(),
        cadence_seconds: z.number().int(),
        last_round: z.number().int(),
        next_round: z.number().int(),
        max_rounds: z.number().int().nullable().optional(),
        scheduled_at: z.iso.datetime({ offset: true }),
        wake_up_at: z.iso.datetime({ offset: true }),
    })
    .strip();

export const outreachMonitorWakeUpDefinitions = {
    outreach_monitor_wake_up: defineInvisible('outreach_monitor_wake_up', {
        disposition: 'invisible',
        schema: outreachMonitorWakeUpPayloadSchema,
        malformed: { kind: 'skip' },
        evidence: null,
    }),
} as const;

export const outreachMonitorWakeUpContractFixtures = {
    valid: {
        type: 'outreach_monitor_wake_up',
        outreach_id: '00000000-0000-4000-8000-000000000001',
        reason: 'Internal wake-up reason',
        cadence_seconds: 300,
        last_round: 1,
        next_round: 2,
        max_rounds: 4,
        scheduled_at: '2026-08-28T12:00:00Z',
        wake_up_at: '2026-08-28T12:05:00Z',
    },
    malformed: {
        type: 'outreach_monitor_wake_up',
        outreach_id: '00000000-0000-4000-8000-000000000001',
        reason: 'Internal wake-up reason',
        cadence_seconds: '300',
        last_round: 1,
        next_round: 2,
        scheduled_at: '2026-08-28T12:00:00Z',
        wake_up_at: '2026-08-28T12:05:00Z',
    },
} as const;
